<div fxLayout="column">
  <app-page-header [section]="'Applications'"
                   [title]="'Hand pick retailers for your leads'"
                   [description]="'These are applicants who’ve expressed interest in joining your curated leads pipeline. Approving them adds them to your pool of retailers that you can choose from when deciding who to place in your spaces.'"></app-page-header>

  <div class="page-padding page-content full-screen-height-page-default" fxLayout="column">
    <div class="mat-elevation-z3 radius-10" fxLayout="column" fxFlexOffset="10px">
      <app-crud-table
        (rowSelected)="retailerSelectedForView($event)"
        [loading$]="loader.loading$"
        [modelType]="CrudRetailer"
        [tableData]="applicationsData"
        [title]="'Applicants to curate'"
        [subTitle]="'Curate all the applicants you want to add to your leads pipeline'">
      </app-crud-table>
    </div>
  </div>

</div>
